import styled from "@emotion/styled";
import { colorGuide } from "../../theme/colors";
import { getColor } from "../../theme/theme";

export const ChipContainer = styled.button<{
  isSelected: boolean;
}>`
  display: inline-flex;
  padding: 6px 10px;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  border: 0.5px solid
    ${({ isSelected, disabled }) => {
      if (disabled) return getColor("border.default.default");
      return isSelected
        ? getColor("border.wishlink.default")
        : getColor("border.default.default");
    }};
  background-color: ${({ isSelected, disabled }) => {
    if (disabled) return getColor("background.default.default");
    return isSelected
      ? getColor("background.wishlink.tertiary")
      : getColor("background.default.default");
  }};
  color: ${({ isSelected, disabled }) => {
    if (disabled) return getColor("text.disabled.on-disabled");
    return isSelected
      ? getColor("text.wishlink.default")
      : getColor("text.neutral.default");
  }};
  font-family: "Rubik", sans-serif;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.2px;
  box-shadow: 0 0 4px 0 #efefef;
  &:disabled {
    cursor: not-allowed;
  }
`;

export const IconWrapper = styled.div<{
  isDisabled?: boolean;
  isSelected?: boolean;
}>`
  display: flex;
  width: 12px;
  height: 12px;
  flex-direction: column;
  justify-content: center;
  cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
  color: ${({ isSelected, isDisabled }) => {
    if (isDisabled) return getColor("icon.disabled.on-disabled");
    return isSelected
      ? getColor("icon.wishlink.default")
      : getColor("icon.neutral.default");
  }};
`;

export const ChipIcon = styled.i`
  font-size: 12px;
`;
